(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('RequiredDocumentDeleteController',RequiredDocumentDeleteController);

    RequiredDocumentDeleteController.$inject = ['$uibModalInstance', 'entity', 'RequiredDocument'];

    function RequiredDocumentDeleteController($uibModalInstance, entity, RequiredDocument) {
        var vm = this;

        vm.requiredDocument = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RequiredDocument.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
